module.exports = __webpack_public_path__ + "img/card-vital-02-slider.8414f3d3.webp";